define.alias("shared/components/shared/pre-boarding/survey/index", "media/components/shared/pre-boarding/survey/index");